import { ReactNode } from 'react';

export interface AdditionalSectionProps {
  title: string;
  children: ReactNode;
  className?: string;
}

export const AdditionalSection = ({ children, title, className = '' }: AdditionalSectionProps) => {
  return (
    <section className={`py-32 ${className}`}>
      <h3 className="mb-32 text-32 font-medium leading-tight tracking-[0.4%]">{title}</h3>
      {children}
    </section>
  );
};
